<app-error-card
  title="403 Forbidden"
  message="Sorry you do not have access to this page. If you think this is a mistake
  please contact your site administrator."
>
  <a class="btn btn-primary" (click)="onCancel()"
    ><i class="bi bi-arrow-left"></i> Return</a
  >
</app-error-card>
